/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FCS API
 * Field Compliance System — REST API
 * OpenAPI spec version: 0.0.54-SNAPSHOT
 */
import type {
  ActionChoiceDto,
  CountActionsToDoDto,
  CreateCustomActionRequest,
  CreateCustomActionResponse,
  DeleteCustomActionParams,
  DeleteCustomActionResponse,
  UpdateCustomActionRequest,
  UpdateCustomActionResponse
} from '../model';

import { customInstance } from '../../mutator/custom-instance';



  export const getActions = () => {
/**
 * Returns the total number of pending actions that the authenticated user must complete
 * across all their in-progress action plans in the specified store. This count is used
 * to display notification badges and remind vendors of outstanding corrective actions.
 * @summary Count actions to do for a user in a store
 */
const countActionsToDoByStore = (
    storeId: number,
 ) => {
      return customInstance<CountActionsToDoDto>(
      {url: `/api/v1/stores/${storeId}/actions/count`, method: 'GET'
    },
      );
    }
  /**
 * Creates one custom action for a specific diagnosis question. Custom
 * actions allow users to define their own corrective measures when the predefined
 * action choices do not apply. The created actions are added to the user's action plan
 * and tracked for completion.
 * @summary create custom actions for a question
 */
const createCustomActions = (
    createCustomActionRequest: CreateCustomActionRequest,
 ) => {
      return customInstance<CreateCustomActionResponse>(
      {url: `/api/v1/custom_actions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createCustomActionRequest
    },
      );
    }
  /**
 * Updates a previously created custom corrective action. This endpoint modifies the
 * action in the user's action plan. Returns 403 if the user is not authorized to update this action or if it has already been completed.
 * @summary update a custom action
 */
const patchCustomAction = (
    updateCustomActionRequest: UpdateCustomActionRequest,
 ) => {
      return customInstance<UpdateCustomActionResponse>(
      {url: `/api/v1/custom_actions`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateCustomActionRequest
    },
      );
    }
  /**
 * Deletes a previously created custom corrective action. This endpoint removes the
 * action from the user's action plan. Returns 403 if the user is not authorized to delete this action or if it has already been completed.
 * @summary Delete a custom action
 */
const deleteCustomAction = (
    params: DeleteCustomActionParams,
 ) => {
      return customInstance<DeleteCustomActionResponse>(
      {url: `/api/v1/custom_actions`, method: 'DELETE',
        params
    },
      );
    }
  /**
 * Retrieves the list of predefined corrective actions available for a specific diagnosis
 * question. When a vendor answers a question negatively, they can select from these
 * action choices to add to their action plan. The labels are returned in the language
 * specified by the Accept-Language header.
 * @summary Get action choices for a question
 */
const findActionChoices = (
    diagnosisId: string,
    questionId: string,
 ) => {
      return customInstance<ActionChoiceDto[]>(
      {url: `/api/v1/diagnoses/${diagnosisId}/questions/${questionId}/action_choices`, method: 'GET'
    },
      );
    }
  return {countActionsToDoByStore,createCustomActions,patchCustomAction,deleteCustomAction,findActionChoices}};
export type CountActionsToDoByStoreResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getActions>['countActionsToDoByStore']>>>
export type CreateCustomActionsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getActions>['createCustomActions']>>>
export type PatchCustomActionResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getActions>['patchCustomAction']>>>
export type DeleteCustomActionResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getActions>['deleteCustomAction']>>>
export type FindActionChoicesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getActions>['findActionChoices']>>>
